import { render, staticRenderFns } from "./Galleries.vue?vue&type=template&id=336f4aa6&"
import script from "./Galleries.vue?vue&type=script&lang=js&"
export * from "./Galleries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336f4aa6')) {
      api.createRecord('336f4aa6', component.options)
    } else {
      api.reload('336f4aa6', component.options)
    }
    module.hot.accept("./Galleries.vue?vue&type=template&id=336f4aa6&", function () {
      api.rerender('336f4aa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Galleries.vue"
export default component.exports